import {
  Component,
  ViewEncapsulation,
  OnInit,
  Inject
} from '@angular/core';

import {
  FormBuilder,
  Validators,
  FormGroup,
  FormControl
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {UserContext} from '../services/user-context';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ApiService} from '../services/api';
import {LoadingIndicatorService} from '../shared/layout/components/loading-indicator';

@Component({
  selector: 'app-payment-source',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'payment-source.template.html',
  styles: [
    "app-payment-source mat-dialog-container {padding:0;}",
    "app-payment-source mat-dialog-content.mat-dialog-content {background:#f7fafc;padding:24px;border-top:1px solid rgb(227, 232, 238); box-shadow:rgb(227, 232, 238) 0px -1px 0px 0px inset;}",
    "app-payment-source mat-dialog-actions {display:flex;flex-direction: row;justify-content: flex-end;padding:0;}",
    "app-payment-source mat-dialog-actions .k-button {height:auto;margin-left:10px;}",
    "app-payment-source .digits {letter-spacing: 2px}",
    "app-payment-source .k-grid .grid-column-header {background:#f1f4f6;font-weight:400!important;}",
    "app-payment-source .k-grid tr.k-alt { background-color: #fcfcfc; }"

  ]
})

export class PaymentSourceComponent implements OnInit {
  public form: FormGroup;

  options:any;
  entity:any;
  customer:any;

  constructor(private formBuilder: FormBuilder,
              public dialogRef: MatDialogRef<PaymentSourceComponent>,
              private snackBar: MatSnackBar,
              public loadingService: LoadingIndicatorService,
              private api: ApiService,
              private userContext: UserContext,
              @Inject(MAT_DIALOG_DATA) public data: any) {

    this.options = Object.assign({mode:'account'},this.data);
    if( this.options.mode === 'user' ) {
      this.entity = {path:'user', id:this.userContext.user.reference};
    } else {
      this.entity = {path:'account', id:this.userContext.account.id}
    }
  }

  public ngOnInit(): void {

    this.buildForm();

    this.refresh();
  }

  private refresh() {
    this.api.get<any>(`/${this.entity.path}/${this.entity.id}/source`)
      .subscribe(result => {
        this.customer = result;
      });
  }

  public buildForm() {
    this.form = this.formBuilder.group({
      number: new FormControl( '', [
        Validators.required,
        Validators.pattern(/^\d{15,16}$/),
        Validators.minLength(15)
      ]),
      exp: new FormControl('', [
        Validators.required,
        Validators.minLength(4)
      ]),
      cvc: new FormControl('', [
        Validators.required,
        Validators.minLength(3)
      ])
    });
  }

  public isAdministrator() {
    return this.userContext.hasRole('administrator');
  }

  public add() {
    this.api.post<any>(`/${this.entity.path}/${this.entity.id}/source`, {
      object: 'card',
      number:this.form.value.number,
      exp_month:this.form.value.exp.substring(0,2),
      exp_year:this.form.value.exp.substring(2),
      cvc:this.form.value.cvc
    })
      .subscribe(result => {
        this.form.reset();
        this.customer = result;
      });
    this.snackBar.open('Payment method added successfully', null, {
      duration: 2000
    });
  }

  public remove( source:any) {
    this.api.del(`/${this.entity.path}/${this.entity.id}/source/${source.id}`)
      .subscribe(result => {
        this.customer = result;
      });
    this.snackBar.open('Payment method removed', null, {
      duration: 2000
    });
  }

  public makeDefault( source:any) {
    this.api.patch<any>(`/${this.entity.path}/${this.entity.id}/source/${source.id}`, {default_source:true})
      .subscribe(result => {
        this.customer = result;
      });
    this.snackBar.open('Default payment method updated', null, {
      duration: 2000
    });
  }

  public cancel() {
    this.dialogRef.close();
  }
}
